import React from "react";

import GroupStats from "./components/GroupStats";
import GroupFilters from "./components/GroupFilters";
import GroupsTable from "./components/GroupsTable";
import GroupsMobileList from "./components/GroupsMobileList";
import GroupDetailsDrawer from "./components/GroupDetailsDrawer";
import GroupsPagination from "./components/GroupsPagination";
import GroupsSkeleton from "./components/GroupsSkeleton";
import GroupsEmptyState from "./components/GroupsEmptyState";

import { useAdminGroups } from "./hooks/useAdminGroups";

function GroupsAdmin() {
  const {
    filteredGroups,
    paginatedGroups,
    filters,
    stats,
    coachOptions,
    selectedGroup,
    isDrawerOpen,
    loading,
    refreshing,
    page,
    totalPages,
    fetchGroups,
    updateFilter,
    resetFilters,
    setPage,
    openGroupDrawer,
    closeGroupDrawer,
  } = useAdminGroups();

  const hasFilters = Boolean(
    filters.search || filters.status || filters.coach || filters.members,
  );

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <GroupsSkeleton />
      ) : (
        <>
          <GroupStats stats={stats} />

          <GroupFilters
            filters={filters}
            coachOptions={coachOptions}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchGroups({ silent: false })}
          />

          {paginatedGroups.length > 0 ? (
            <>
              <GroupsTable
                groups={paginatedGroups}
                onOpen={openGroupDrawer}
              />

              <GroupsMobileList
                groups={paginatedGroups}
                onOpen={openGroupDrawer}
              />

              <GroupsPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredGroups.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <GroupsEmptyState
              hasFilters={hasFilters}
              onReset={resetFilters}
            />
          )}

          <GroupDetailsDrawer
            isOpen={isDrawerOpen}
            group={selectedGroup}
            onClose={closeGroupDrawer}
          />
        </>
      )}
    </div>
  );
}

export default GroupsAdmin;